'use client';
import styled from 'styled-components';
import { breakPoints } from '@/styles';
export const BlogPost = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  max-width: 800px;
  margin: 20px auto 20px;
  font-family:
    Mulish,
    -apple-system,
    BlinkMacSystemFont,
    Segoe UI,
    Helvetica,
    Arial,
    sans-serif;

  @media (max-width: ${breakPoints.mobilePortrait}) {
    max-width: 100%;
    margin: 20px;
  }
`;

export const BlogPostHeader = styled.div`
  display: flex;
  flex-direction: column;
  /* align-items: center; */
  gap: 10px;
  h1 {
    display: block;
    font-family:
      Mulish,
      -apple-system,
      BlinkMacSystemFont,
      Segoe UI,
      Helvetica,
      Arial,
      sans-serif;
    font-weight: 800;
    font-size: 3.2rem;
    letter-spacing: -0.1rem;
    line-height: 1.2;
    margin-top: 20px;
    margin-bottom: 0;
    word-break: break-word;
    text-align: center;
    @media (max-width: ${breakPoints.mobile}) {
      font-size: 2.4rem;
    }
  }
`;
